import { useState, useEffect } from "react";
import api from "../api/config";
import Schedule from "./Schedule";

const App = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        let response = await api.get();
        setConfig(response.data);
      } catch {
        setConfig([]);
      }
    })();
  }, []);

  if (config) {
    if (config.length === 0) {
      return (
        <div>
          An error occurred while loading the schedule. Please try refreshing
          the page.
        </div>
      );
    }

    return <Schedule config={config} />;
  }

  return <div>Loading...</div>;
};

export default App;
